export default {
    FRAME: 'FRAME',
    IMAGE_LINK: 'IMAGE_LINK',
    MENTION: 'MENTION',
    NO_FOLLOW: 'NO_FOLLOW',
    OTHER: 'OTHER',
    REDIRECT: 'REDIRECT',
    TEXT_LINK: 'TEXT_LINK',
};
